import { RibbonGroupBase } from '../ribbon-interfaces';
import { RIBBON_ID } from '../ribbon-base/ribbon-constants';
export const CELL_PROPERTIES_GROUP_ID = '_cell_properties_group';
export const MERGE_CELLS_BUTTON_ID = '_merge_cells_button';
/**
 * Represents the Cell Properties Group in Table Layout tab
 * @private
 */
export class CellPropertiesGroup extends RibbonGroupBase {
    /**
     * Constructor for the CellPropertiesGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
        this.commonID = this.container.element.id + RIBBON_ID;
    }
    /**
     * Gets the ribbon group model for Cell Properties
     * @returns {RibbonGroupModel} - Ribbon group model
     */
    getGroupModel() {
        return {
            id: this.commonID + CELL_PROPERTIES_GROUP_ID,
            header: this.localObj.getConstant('Cell Properties'),
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Cell Properties'),
            collections: [
                {
                    items: [
                        this.getMergeCellsButton()
                        // Additional cell property buttons can be added here
                    ]
                }
            ]
        };
    }
    /**
     * Gets the Merge Cells button model
     * @returns {RibbonItemModel} - Ribbon item model for Merge Cells button
     */
    getMergeCellsButton() {
        return {
            type: 'Button',
            id: this.commonID + MERGE_CELLS_BUTTON_ID,
            disabled: true,
            keyTip: 'M',
            buttonSettings: {
                content: this.localObj.getConstant('Merge cells'),
                iconCss: 'e-icons e-de-ctnr-mergecell',
                clicked: () => this.mergeSelectedCells()
            },
            ribbonTooltipSettings: {
                content: this.localObj.getConstant('Merge cells')
            }
        };
    }
    /**
     * Merges the selected cells
     * @returns { void }
     */
    mergeSelectedCells() {
        this.documentEditor.editorModule.mergeCells();
    }
    /**
     * Checks if cells can be merged
     * @returns {boolean} - True if cells can be merged, false otherwise
     */
    canMergeCells() {
        return this.documentEditor.editorModule.canMergeCells();
    }
    /**
     * Updates the merge cells button state based on selection
     * @returns {void}
     */
    updateSelection() {
        this.updateMergeCellsButtonState();
    }
    /**
     * Updates the merge cells button enabled/disabled state
     * @returns {void}
     */
    updateMergeCellsButtonState() {
        const id = this.commonID + MERGE_CELLS_BUTTON_ID;
        const ribbon = this.container.ribbon.ribbon;
        if (this.canMergeCells()) {
            ribbon.enableItem(id);
        }
        else {
            ribbon.disableItem(id);
        }
    }
}
